<script>
export default {
  props: {
    press: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<template>
  <div v-if="press.length" class="flex flex-col space-y-7 pt-3">
    <div class="w-full text-left mb-6">
      <h4 class="text-xl font-sans text-dark-gray">Пресса</h4>
      <h6 class="font-sans font-base text-primary"></h6>
    </div>
    <div class="w-full text-left flex flex-col space-y-5">
      <template v-for="item in press" :key="item._id">
        <a v-if="item" target="blank" :href="item.link">
          <article>
            <h5 class="text-lg font-sans text-dark-gray">
              {{ item.name }}
            </h5>
            <h6 class="text-lg font-sans text-primary">
              {{ item.author }}
            </h6>
          </article>
        </a>
      </template>
    </div>
  </div>
</template>
